import { notificationIcon2 } from "assets/icons";
import { surveyPlaceholderImg } from "assets/images";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { getFromLocal } from "config/axiosInstance";
import useShimmer from "hooks/useShrimmer";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowUp, FaBell, FaTimes } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";
import { fetchUserNotificationApi } from "services/notification";
import NotificationShrimmer from "shrimmer/Notification/NotificationShrimmer";
import {
  charLimit,
  getMessageLabel,
  getValueOrFallback,
  isTrue,
} from "utils/commonHelper";
import { convertToTime } from "utils/dateHelper";

const Notification = () => {
  // set all value
  const [notificationList, setNotificationList] = useState([]);
  const [messageCount, setMessageCount] = useState("");
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  //   Hooks Handler
  const { t } = useTranslation();
  const [showNotificationShrimmer, setShowNotificationShrimmer] =
    useShimmer(NotificationShrimmer);

  const fetchNotificationList = async (activePage) => {
    try {
      setShowNotificationShrimmer(true);
      const sendData = {
        token: getFromLocal(),
        page: activePage,
        limit: limit,
      };
      const responseData = await fetchUserNotificationApi(sendData);
      const {
        data: { notification = [], total = 0, unreadMessageCount = 0 },
        status,
      } = responseData;
      if (status === 200) {
        if (Number(page) === 1) {
          setNotificationList(notification);
        } else {
          setNotificationList((prevNotificationList) => [
            ...prevNotificationList,
            ...notification,
          ]);
        }
        setTotal(total);
        setMessageCount(unreadMessageCount);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowNotificationShrimmer(false);
    }
  };

  useEffect(() => {
    fetchNotificationList(page);
  }, [page]);

  return (
    <Dropdown className="customDropdown notification_dropdown">
      <Dropdown.Toggle id="dropdown-basic">
        <FaBell />
        {isTrue(messageCount) && <span>{messageCount}</span>}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className="title">
          <h4>{t("NOTIFICATION.notification")}</h4>
          <Dropdown.Item>
            <FaTimes />
          </Dropdown.Item>
        </div>
        <ul id="notification-list">
          {Number(page) === 1 && showNotificationShrimmer ? (
            showNotificationShrimmer
          ) : (
            <InfiniteScroll
              dataLength={notificationList?.length || 0}
              next={() => setPage((prev) => prev + 1)}
              hasMore={notificationList?.length < total}
              loader={showNotificationShrimmer}
              scrollableTarget="notification-list"
              scrollThreshold={0.5}
              // inverse={true}
              endMessage={
                Number(page) > 1 && (
                  <p
                    style={{ textAlign: "center", cursor: "pointer" }}
                    onClick={() => {
                      const container =
                        document.getElementById("notification-list");
                      if (container) {
                        container.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    <b>{t(`NOTIFICATION.noNotificationList`)}</b> <FaArrowUp />
                  </p>
                )
              }
            >
              {notificationList && notificationList?.length > 0 ? (
                notificationList?.map(
                  ({ title, message, createdAt }, index, notificationArray) => {
                    const messageLabel = getMessageLabel(createdAt);
                    const showLabel =
                      index === 0 ||
                      getMessageLabel(
                        notificationArray[index - 1]?.createdAt
                      ) !== messageLabel;
                    return (
                      <>
                        {showLabel && messageLabel}
                        <li key={`notification-list-${index}`}>
                          <img src={notificationIcon2} alt="" />{" "}
                          <div>
                            <b>
                              <p>{getValueOrFallback(title)}</p>
                            </b>
                            <p>{charLimit(getValueOrFallback(message), 45)}</p>
                          </div>
                          <small>{convertToTime(createdAt)}</small>
                        </li>
                      </>
                    );
                  }
                )
              ) : (
                <NotFoundPlaceHolder
                  title={t(`NOTIFICATION.notificationNotFound`)}
                  placeHolderImage={surveyPlaceholderImg}
                  className="mySurveyList"
                />
              )}
            </InfiniteScroll>
          )}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Notification;
